window.addEventListener('load', event => {
    const contactFormPanel = document.getElementById('contactFormPanel');

    if (contactFormPanel) {
        const formPicker = contactFormPanel.querySelector('[data-form-switcher]');
        const formPickerButtons = contactFormPanel.querySelectorAll('button[data-show-form]');

        if (formPicker) {
            formPicker.addEventListener('click', (event) => {
                const target = event.target;
                const textTarget = formPicker.querySelector('[data-form-text-target]');
                const emailInput = formPicker.querySelector('input[name="email"]');
                const phoneInput = formPicker.querySelector('input[name="contactNumber"]');
                const preferredContactInput = formPicker.querySelector('input[name="preferredContactMethod"]');

                if (target.matches('button[data-show-form]')) {

                    if (target.dataset.active === 'true') {
                        formPicker.dataset.open = 'false'
                        target.dataset.active = 'false';
                    } else {
                        const showForm = target.dataset.showForm;
                        const formText = target.dataset.formText;
                        const inputTarget = target.dataset.inputTarget;
                        const input = formPicker.querySelector(`input[name="${inputTarget}"]`);

                        if (emailInput && phoneInput && input) {
                            const emailInputLabel = emailInput.previousElementSibling;
                            const phoneInputLabel = phoneInput.previousElementSibling;
                            const inputLabel = input.previousElementSibling;

                            emailInput.removeAttribute('required');
                            phoneInput.removeAttribute('required');
                            input.setAttribute('required', 'true');

                            emailInputLabel?.classList.remove("after:content-['*']");
                            phoneInputLabel?.classList.remove("after:content-['*']");
                            inputLabel?.classList.add("after:content-['*']");
                        }

                        if (preferredContactInput && showForm) {
                            preferredContactInput.value = showForm;
                        }

                        if (textTarget && formText) {
                            textTarget.innerText = formText;
                        }

                        if (formPicker.dataset.open === 'false') {
                            formPicker.dataset.open = 'true'
                        }

                        formPickerButtons.forEach(formPickerButton => {
                            formPickerButton.dataset.active = 'false';
                        });

                        target.dataset.active = 'true';
                    }
                }
            });
        }
    }
});